import React, { useState } from 'react';
import { AVATARS } from '../utils/avatars';
import { cn } from '../lib/utils';
import { User } from 'lucide-react';

interface GalleryPhotoProps {
  id: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export default function GalleryPhoto({ id, size = 'md', className }: GalleryPhotoProps) {
  const avatar = AVATARS.find(a => a.id === id) || AVATARS[0];
  const [error, setError] = useState(false);
  
  const sizeClasses = {
    sm: 'w-8 h-8 rounded-md',
    md: 'w-12 h-12 rounded-lg',
    lg: 'w-16 h-16 rounded-lg',
    xl: 'w-24 h-24 rounded-xl'
  };

  // If a width/height is passed in className, we don't apply fixed sizeClasses
  const hasSizeInClass = className?.includes('w-') || className?.includes('h-');

  return (
    <div 
      className={cn(
        !hasSizeInClass && sizeClasses[size],
        "relative overflow-hidden shadow-sm flex items-center justify-center bg-slate-900 group",
        className
      )}
    >
      {/* The Gallery Art (Abstract Composition) */}
      {avatar.id === 'g1' ? (
        <div className="w-full h-full bg-black" />
      ) : !error ? (
        <img 
          src={avatar.imagePath} 
          alt={avatar.name}
          onError={() => setError(true)}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-slate-800">
           <User className="w-1/2 h-1/2 text-slate-500" />
        </div>
      )}

      {/* Glassmorphism Polish Layer */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent pointer-events-none mix-blend-overlay" />
      <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-inherit" />
    </div>
  );
}
